import React from "react";
import "../styles/styles.css";

function AboutPage() {
  return (
    <div className="about-page">
      <h1 className="about-title">Sobre nosotros</h1>
      <div className="about-container">
        {/* Sección de información */}
        <div className="about-info">
          <h2>Sobre Nuestra Empresa</h2>
          <p>
En CYBER SOFIA TECHNOLOGY, contamos con más de 10 años de experiencia ofreciendo 
soluciones rápidas y profesionales para la gestión y creación de documentos. 
Nuestra plataforma web intuitiva y moderna facilita a nuestros clientes resolver 
sus necesidades documentales desde la comodidad de su hogar, garantizando calidad, 
ahorro de tiempo y resultados excepcionales.  
          </p>
          <p>
          <h2> Misión:</h2> 
          Empoderar a nuestros clientes con herramientas digitales para la gestión de documentos y trámites legales, construyendo una base sólida de clientes fieles y satisfechos.  
         </p>
         <p>
         <h2>Visión:</h2>  
         Ser líderes en soluciones digitales para documentos en línea, estableciendo un nuevo estándar de calidad y accesibilidad.
          </p>
        </div>
        {/* Imagen */}
        <div className="about-image">
          <img
            src="/files/img/about.png"
            alt="empoderar a nuestros clientes con herramientas digitales y liderar en soluciones de documentos en línea con calidad y accesibilidad. #Innovación #Calidad #LiderazgoDigita"
            className="responsive-image"
          />
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
